import { useMyMemberships } from '../gym/useMyMemberships'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router'
import { profileFixLink } from '../profile/profileFixLink'
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@structural-climbing/ui'

interface Props {
  isOpen: boolean
  onClose: () => void
}

/**
 * Competitors are ranked in a men's or a women's category, so a member who has
 * not given a gender cannot be placed. Rather than hiding the Join button, we
 * let them tap it and explain what is missing, with a way to fix it.
 */
export function GenderRequiredModal({ isOpen, onClose }: Props) {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  // A child's profile is the parent's to fill in, so there is nowhere to send them.
  const isChildAccount = useMyMemberships().childAccount !== null

  return (
    <Modal isOpen={isOpen} onClose={onClose} placement="center">
      <ModalContent>
        <ModalHeader>
          {isChildAccount
            ? t('competitions.childDetailsTitle')
            : t('competitions.genderRequiredTitle')}
        </ModalHeader>
        <ModalBody>
          <p className="text-sm text-foreground/70">
            {isChildAccount
              ? t('competitions.childDetailsBody')
              : t('competitions.genderRequiredBody')}
          </p>
        </ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={onClose}>
            {t('common.cancel')}
          </Button>
          {!isChildAccount && (
            <Button
              as={Link}
              to={profileFixLink('gender', pathname)}
              color="primary"
              onPress={onClose}
            >
              {t('competitions.genderRequiredCta')}
            </Button>
          )}
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
